import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSubscribe } from "../../apiHooks/common";

import { clearEmail, linkArrowRight } from "../../svgs";

import { EmailWrapper } from "./styled";

const CustomEmailInput = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const {
    subscribe,
    loading,
    isSuccess,
    isError,
    responseMessage,
    errorMessage,
  } = useSubscribe();

  const [responseMsg, setResponseMsg] = useState("");
  useEffect(() => {
    if (isError && errorMessage) {
      const errorResponse = errorMessage as {
        response: { data: { email: string[] | undefined; message: string } };
      };
      const emailError = errorResponse?.response?.data?.email;
      const messageError = errorResponse?.response?.data?.message;
      const errorMsg = emailError?.[0] || messageError || "დაფიქსირდა შეცდომა";

      setResponseMsg(errorMsg);
    } else if (isSuccess && responseMessage) {
      const response = responseMessage as {
        data: { message: string };
      };
      setResponseMsg(response?.data?.message);
    }
  }, [errorMessage, isError, responseMessage, isSuccess]);

  const [emailInput, setEmailInput] = useState("");

  const onSubmit = (data) => {
    // console.log(data);
    if (data.email.length === 0) {
      return; // Exit early if email length is 0
    }
    subscribe(data?.email);
  };

  const handleClear = () => {
    setEmailInput("");
    setResponseMsg("");
  };

  return (
    <EmailWrapper>
      {!isSuccess ? (
        <>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-wrapper">
              <input
                type="email"
                className={`email-input ${
                  isError && responseMsg && emailInput.length > 0
                    ? "warning"
                    : ""
                }  ${errors.email && emailInput.length > 0 ? "invalid" : ""}`}
                {...register("email", {
                  required: {
                    value: true,
                    message: t("emailRequired"),
                  },
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "მეილი არასწორია",
                  },
                })}
                placeholder="შეიყვანე მეილი"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
              />

              {emailInput.length === 0 ? (
                <button type="button" className="submit-button">
                  {linkArrowRight()}
                </button>
              ) : (
                emailInput.length < 8 && (
                  <button
                    type="submit"
                    className="clear-button"
                    onClick={handleClear}
                  >
                    {clearEmail()}
                  </button>
                )
              )}

              {emailInput.length >= 8 && (
                <>
                  <button type="submit" className="submit-button">
                    {linkArrowRight()}
                  </button>
                  <button
                    type="button"
                    className="x-button"
                    onClick={handleClear}
                  >
                    {clearEmail()}
                  </button>
                </>
              )}
            </div>
            {errors.email && emailInput.length > 0 ? (
              <div className="error-message">მეილი არასწორია</div>
            ) : (
              !isSuccess &&
              emailInput.length > 0 && (
                <div className="warning-message">{responseMsg}</div>
              )
            )}
          </form>

          <p className="mail-p" style={{ marginTop: "12px" }}>
            გამოიწერე სიახლეები
          </p>
        </>
      ) : (
        <div className="success-message">
          {isSuccess && !loading && responseMsg} <span> {"<3"} </span>
        </div>
      )}
    </EmailWrapper>
  );
};

export default CustomEmailInput;
